/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Meta_DisconnectedInputs */

const cs_social_hub_meta_disconnected = /** @type {(inputs: Social_Hub_Meta_DisconnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřipojeno`)
};

const en_social_hub_meta_disconnected = /** @type {(inputs: Social_Hub_Meta_DisconnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected`)
};

/**
* | output |
* | --- |
* | "Not connected" |
*
* @param {Social_Hub_Meta_DisconnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_meta_disconnected = /** @type {((inputs?: Social_Hub_Meta_DisconnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Meta_DisconnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_meta_disconnected(inputs)
	return cs_social_hub_meta_disconnected(inputs)
});